"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = multiFieldMaxLength;

var _isWithinMaxLength = _interopRequireDefault(require("./isWithinMaxLength"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MAX_LENGTH = 50; // If one of the fields exceeds the limit. It will return false, otherwise true.

function multiFieldMaxLength(row) {
  var maxlength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MAX_LENGTH;

  var isValidLength = function isValidLength(val) {
    return (0, _isWithinMaxLength["default"])(val, maxlength);
  };

  var columns = Object.values(row);
  return columns.every(function (column) {
    // If a field is an array check each items for valid length
    if (Array.isArray(column)) {
      return column.every(isValidLength);
    }

    return isValidLength(column);
  });
}